module.exports = __webpack_public_path__ + "static/devvjob-c22152895c9f5f0defbd69115ee922b9.png";